import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, from } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';

import { PermissionsService } from '@services/permissions.service';

let isRefreshing = false;
const refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

export const TokenInterceptorFn: HttpInterceptorFn = (req, next) => {
  const permissionService = inject(PermissionsService);

  // Excluye las peticiones de login para evitar bucles
  if (req.url.includes('/auth')) {
    // console.log('login')
    return next(req);
  }

  // Agrega el token de acceso a la cabecera
  const accessToken = permissionService.getToken();
  if (accessToken) {
    // console.log('token',accessToken)
    req = addToken(req, accessToken);
  }

  // Maneja la petición y el error 401 para refrescar el token
  return next(req).pipe(
    catchError((error: any) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          // Llama al servicio que se encarga del refresh token
          return permissionService.refreshToken().pipe(
            switchMap((tokens: any) => {
              // console.log('refresh', tokens);
              isRefreshing = false;
              permissionService.saveToken(tokens.token);
              permissionService.saveRefreshToken(tokens.token);
              refreshTokenSubject.next(tokens.token);
              return next(addToken(req, tokens.token));
            }),
            catchError((err: any) => {
              isRefreshing = false;
              permissionService.logout(); // Cierra sesión si el refresh falla
              return throwError(() => err);
            })
          );
        } else {
          // Si ya hay una petición de refresh en curso, espera por el nuevo token
          return refreshTokenSubject.pipe(
            filter((token) => token !== null),
            take(1),
            switchMap((token) => {
              return next(addToken(req, token));
            })
          );
        }
      }
      return throwError(() => error);
    })
  );
};

function addToken(request: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
  return request.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}
